<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Others Info</v-expansion-panel-title
                            >
                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submit"
                                ref="addEmployee"
                                id="addEmployee"
                                >
                                <v-row class="pa-2">
                                    <v-col cols="12">
                                        <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="sale_invoice_master_id.value.value"
                                            :items="getSaleInvoiceList"
                                            :item-title="(item) => `${item.code}`"
                                            item-value="id"
                                            @update:modelValue="onSaleInvoiceChange"
                                            :error-messages="sale_invoice_master_id.errorMessage.value"
                                            autocomplete="off"
                                            :disabled="requisitionDisable"
                                            clearable
                                        >
                                            <template #label>
                                                Sale Invoice
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete>

                                        <v-date-input
                                            input-format="dd/mm/yyyy"
                                            label="Invoice Delivery Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="invoice_delivery_date.value.value"
                                            :error-messages="invoice_delivery_date.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        ></v-date-input>

                                        <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="warehouse_id.value.value"
                                            :items="getWarehouseList"
                                            :item-title="(item) => `${item.name}`"
                                            item-value="id"
                                            :error-messages="warehouse_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                Warehouse
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete>


                                        <!-- <v-date-input
                                            input-format="dd/mm/yyyy"
                                            label="Approximate Delivery Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="approximate_delivery_date.value.value"
                                            :error-messages="approximate_delivery_date.errorMessage.value"
                                            autocomplete="off"
                                            :readonly="true"
                                        ></v-date-input> -->

                                        <!-- <v-date-input
                                            input-format="dd/mm/yyyy"
                                            label="Shiping Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="shipping_date.value.value"
                                            :error-messages="shipping_date.errorMessage.value"
                                            autocomplete="off"
                                            :readonly="true"
                                        ></v-date-input> -->

                                        <v-text-field
                                            label="Delivery Address"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="delivery_address.value.value"
                                            :error-messages="delivery_address.errorMessage.value"
                                            autocomplete="off"
                                            :readonly="true"
                                        ></v-text-field>

                                        <v-text-field
                                            label="Customer Name"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="customer_name.value.value"
                                            :error-messages="customer_name.errorMessage.value"
                                            autocomplete="off"
                                            :readonly="true"
                                        ></v-text-field>


                                        <v-text-field
                                            label="Requsition By"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requsition_by.value.value"
                                            :error-messages="requsition_by.errorMessage.value"
                                            autocomplete="off"
                                            :disabled="true"
                                            clearable
                                        ></v-text-field>

                                        <v-text-field
                                            label="Requsition By Mobile"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requsition_by_mobile.value.value"
                                            :error-messages="requsition_by.errorMessage.value"
                                            autocomplete="off"
                                            :disabled="true"
                                            clearable
                                        ></v-text-field>

                                        <v-text-field
                                            label="Requsition By Email"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requsition_by_email.value.value"
                                            :error-messages="requsition_by_email.errorMessage.value"
                                            :disabled="true"
                                            autocomplete="off"
                                            clearable
                                        ></v-text-field>

                                    </v-col>
                                </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Item Info
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submit"
                                ref="addEmployee"
                                id="addEmployee"
                                >
                                    <v-row class="pt-2 justify-center">
                                        <v-col cols="8">
                                            <v-autocomplete
                                                class="d-none"
                                                label="Search Prdouct Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value"
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                                                item-value="product_id"
                                                :error-messages="product_id.errorMessage.value"
                                                @update:model-value="addCart"
                                                @keydown.enter="addCart"
                                                autocomplete="off"
                                                clearable
                                            ></v-autocomplete>

                                            <input
                                                v-model="sale_invoice_master_id.value.value"
                                                type="hidden"
                                            />
                                        </v-col>

                                        <!-- <v-col cols="1">
                                            <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                                        </v-col> -->
                                    </v-row>

                                    <!-- Cart Table -->
                                    <v-row class="pt-0">
                                        <v-col cols="12">
                                            <v-table
                                                density="compact"
                                                :loading="loading"
                                                fixed-header
                                                class="table-dotted-border-bottom"
                                                style="height: 40vh; overflow-y: scroll"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th class="text-center" style="width: 5%">SL</th>
                                                        <th class="text-start" style="width: 25%">Product Code</th>
                                                        <th class="text-left" style="width: 25%">Product Name</th>
                                                        <th class="text-start" style="width: 25%">Invoice Qty.</th>
                                                        <th class="text-center" style="width: 15%">Available Qty.</th>
                                                        <th class="text-center" style="width: 15%">Delivery Qty.</th>
                                                        <th v-if="isFreeItem" class="text-center" style="width: 15%">Free Qty.</th>
                                                        <th class="text-center" style="width: 15%">Remaining Qty.</th>
                                                        <th class="text-center" style="width: 15%">Unit</th>
                                                        <th class="text-center" style="width: 10%">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(item, index) in cart" v-if="cart.length > 0"  :key="index">
                                                        <tr @click="isGiftItem ? (expandedIndex = expandedIndex === index ? null : index) : null"
                                                                style="cursor:pointer; background-color: #d3f2c5;" >
                                                            <td class="text-center py-1">{{ index + 1 }}</td>
                                                            <td
                                                            class="text-left py-1"
                                                            style="white-space: normal"
                                                            >
                                                                {{ item.product_code }} 
                                                            </td>
                                                            <td
                                                            class="text-left py-1"
                                                            style="white-space: normal"
                                                            >
                                                                {{ item.product_name }}
                                                            </td>

                                                            <td
                                                            class="text-left py-1"
                                                            style="white-space: normal"
                                                            >
                                                                {{ item.invoice_qty }} 
                                                            </td>
                                                            
                                                            <td class="text-center py-1">
                                                                {{ item.available_qty }}
                                                            </td>
                                                        

                                                            <td class="text-right py-1">
                                                                <v-text-field
                                                                :reverse="false"
                                                                controlVariant="stacked"
                                                                label=""
                                                                style="width: 80px"
                                                                type="number"
                                                                :hideInput="false"
                                                                :inset="false"
                                                                :min="1"
                                                                density="compact"
                                                                :disabled="deliveryQtyDisable"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                v-model="item.qty"
                                                                :error-messages="item.qty < 1 || item.qty > item.available_qty ? 'Insufficient Stock': '' "
                                                                ></v-text-field>
                                                            </td>

                                                            <td v-if="isFreeItem" class="text-right py-1">
                                                                <v-text-field
                                                                controlVariant="stacked"
                                                                label=""
                                                                style="width: 80px"
                                                                type="number"
                                                                :hideInput="false"
                                                                :inset="false"
                                                                :min="1"
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                v-model="item.free_qty"
                                                                ></v-text-field>
                                                            </td>

                                                            <td class="text-center py-1">
                                                                {{ remainingQuantity(item) }}
                                                            </td>
                                                            
                                                            <td class="text-center py-1">
                                                                {{ item.unit_name }}
                                                            </td>
                                                            <td style="white-space: nowrap;" class="text-center py-1">
                                                                <v-icon
                                                                    size="small"
                                                                    color="red"
                                                                    class="delete-button"
                                                                    @click="removeFromCart(index)"
                                                                >
                                                                    mdi-delete
                                                                </v-icon>
                                                                <v-btn v-if="isGiftItem" icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input">
                                                                    <v-icon color="blue">mdi-gift-open</v-icon>
                                                                </v-btn>
                                                                <v-icon v-if="isGiftItem" size="small">
                                                                    {{ expandedIndex === index ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                                                </v-icon>
                                                            </td>
                                                        </tr>

                                                        <tr class="pa-0" >
                                                            <td colspan="100%" class="pa-0" style="height: 0px;">
                                                                <v-expand-transition >
                                                                    <div v-if="expandedIndex === index" :key="'expand-' + index" class="d-flex flex-column">
                                                                        
                                                                            <v-table density="compact" :loading="loading" fixed-header
                                                                                class="table-dotted-border-bottom">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th class="text-center" style="width: 5%">SL</th>

                                                                                        <th class="text-left" style="width: 30%">
                                                                                            Product
                                                                                        </th>

                                                                                        <th class="text-center" style="width: 10%">Unit</th>

                                                                                        <th class="text-left" style="width: 10%">
                                                                                            Quantity
                                                                                        </th>

                                                                                        <th class="text-left" style="width: 15%">
                                                                                            Rate
                                                                                        </th>

                                                                                        <th class="text-center" style="width: 15%">
                                                                                            Amount
                                                                                        </th>
                                                                                        <th class="text-center" style="width: 20%">
                                                                                            Desc.
                                                                                        </th>
                                                                                        <th class="text-center" style="width: 10%">
                                                                                            Lot No.
                                                                                        </th>
                                                                                        <th class="text-right" style="width: 5%">Action</th>
                                                                                    </tr>
                                                                                </thead>

                                                                                <tbody>
                                                                                    <tr v-if="item.gifts.length == 0" style="" >
                                                                                        <td colspan="100%">
                                                                                        <div style="width:100%; display:flex; justify-content:center; padding:20px;">
                                                                                                <v-btn  class="bg-primary pa-2" style="height:30px; font-size:12px;" variant="flat"  @click="addGiftItem(index)"> <v-icon color="white">mdi-plus</v-icon> Gift</v-btn>
                                                                                        </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <template v-for="(giftItem, giftIndex) in item.gifts"  :key="giftIndex">
                                                                                        <tr v-if="item.gifts.length > 0" style="" >
                                                                                            <td class="text-center py-1">{{ giftIndex + 1 }}</td>

                                                                                            <td class="text-left py-1" style="white-space: normal">
                                                                                                {{ giftItem.product?.name }}
                                                                                            </td>

                                                                                            <td class="text-center py-1">
                                                                                                {{ giftItem.product?.unit?.name }}
                                                                                            </td>

                                                                                            <td class="text-left py-1">
                                                                                                <v-text-field 
                                                                                                    :reverse="false" 
                                                                                                    controlVariant="stacked"
                                                                                                    style="width: 80px" 
                                                                                                    label="" :hideInput="false"
                                                                                                    :inset="false" 
                                                                                                    :min="1" 
                                                                                                    type="number" 
                                                                                                    density="compact"
                                                                                                    variant="outlined" 
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.qty" 
                                                                                                    hide-details 
                                                                                                    :error="giftItem.qty < 0"
                                                                                                    :error-messages="giftItem.qty < 0 ? 'Rate must be greater than or equal 0' : ''"
                                                                                                    @update:model-value="giftItem.total = giftItem.qty * giftItem.qty"
                                                                                                    @blur="giftItem.total = giftItem.qty * giftItem.qty"
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>

                                                                                            <td class="text-left py-1">
                                                                                                <v-text-field 
                                                                                                    :reverse="false" 
                                                                                                    controlVariant="stacked"
                                                                                                    style="width: 120px" 
                                                                                                    label="" :hideInput="false"
                                                                                                    :inset="false" 
                                                                                                    :min="0" 
                                                                                                    type="number" 
                                                                                                    density="compact"
                                                                                                    variant="outlined" 
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.sale_rate" 
                                                                                                    hide-details 
                                                                                                    :error="giftItem.sale_rate < 0"
                                                                                                    :error-messages="giftItem.sale_rate < 0 ? 'Rate must be greater than or equal 0' : ''"
                                                                                                    @update:model-value="giftItem.total = giftItem.qty * giftItem.sale_rate"
                                                                                                    @blur="giftItem.total = giftItem.qty * giftItem.sale_rate"
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>

                                                                                            <td class="text-center py-1">
                                                                                                {{ this.$numberFormat(giftItem.total) }}
                                                                                            </td>

                                                                                            <td class="text-left py-1">
                                                                                                <v-text-field 
                                                                                                    :reverse="false" 
                                                                                                    controlVariant="stacked"
                                                                                                    style="width: 100px" 
                                                                                                    label="" 
                                                                                                    :hideInput="false"
                                                                                                    :inset="false" 
                                                                                                    type="text" 
                                                                                                    density="compact"
                                                                                                    variant="outlined" 
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.description" 
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>
                                                                                            <td class="text-left py-1">
                                                                                                <v-text-field 
                                                                                                    :reverse="false" 
                                                                                                    controlVariant="stacked"
                                                                                                    style="width: 80px" 
                                                                                                    label="" :hideInput="false"
                                                                                                    :inset="false" 
                                                                                                    type="text" 
                                                                                                    density="compact"
                                                                                                    variant="outlined" 
                                                                                                    bg-color="grey-lighten-4"
                                                                                                    v-model="giftItem.lot_no" 
                                                                                                    >
                                                                                                </v-text-field>
                                                                                            </td>
                                                                                            <td class="text-center py-1" style="width:200px;">
                                                                                                <div class="d-flex justify-content-center">
                                                                                                    <v-btn icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input" @click="removeGiftItem(index, giftIndex)">
                                                                                                        <v-icon color="red">mdi-close</v-icon>
                                                                                                    </v-btn>

                                                                                                    <v-btn v-if="giftIndex == item.gifts.length - 1" variant="tonal" icon size="small" color="primary" class="breakdown-input" @click="addGiftItem(index)">
                                                                                                        <v-icon color="blue">mdi-plus</v-icon>
                                                                                                    </v-btn>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </template >
                                                                                </tbody>
                                                                            </v-table>

                                                                    </div>
                                                                </v-expand-transition>
                                                            </td>
                                                        </tr>

                                                    </template>
                                                </tbody>
                                            </v-table>
                                        </v-col>
                                    </v-row>
                                    <!-- Close Cart Table -->

                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="pt-2">
                                        <v-col cols="8">
                                            <v-textarea
                                            label="Description"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="remarks.value.value"
                                            :error-messages="remarks.errorMessage.value"
                                            autocomplete="off"
                                            rows="3"
                                            clearable
                                            ></v-textarea>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-layout class="justify-end">
                                            <v-btn
                                            class="bg-grey-darken-1 me-2"
                                            variant="flat"
                                            @click="submitForm(0)"
                                            >DRAFT</v-btn>
                                            <v-btn
                                            class="bg-primary"
                                            variant="flat"
                                            @click="submitForm(1)"
                                            >POST</v-btn>
                                            </v-layout>
                                        </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import { getCompanyInfo } from '@/plugins/helpers'

export default {
    components: {},
    data: () => ({
        expandedIndex: null,
        isFreeItem:false,
        isGiftItem:false,
        isEntryMode: true,
        panel: [0],
        panel2: [0],
        loading: false,
        errorMessages: "",
        visible: false,
        deliveryQtyDisable: false,
        requisitionDisable: false,
        search: "",
        selectedImage: null,
        photo_imageFile: "",
        preview: "/src/assets/no_preview.png",
        cart: [],
    }),
    watch: {},
    created() {
        if (this.$store.getters.getHrmDepartmentList.length === 0) {
            this.$store.dispatch("getHrmDepartmentList");
        }
        if (this.$store.getters.getWarehouseList.length === 0) {
            this.$store.dispatch("getWarehouseList");
        }
        if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        }
        // if (this.$store.getters.getSaleInvoiceList.length === 0) {
            this.$store.dispatch("getSaleInvoiceList", {type:'sales_invoice_for_delivery'});
        // }
    },
    computed: {
        getHrmDepartmentList() {
            return this.$store.getters.getHrmDepartmentList;
        },
        getWarehouseList() {
            return this.$store.getters.getWarehouseList;
        },
        getSaleInvoiceList() {
            return this.$store.getters.getSaleInvoiceList;
        },
        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) =>
                item.branch_id == this.$store.getters.getAuthUser.branch_id &&
                item.status == 1
            );
        },
    },
    methods: {
        remainingQuantity(item) {
            if (!item.invoice_qty || item.invoice_qty <= 0 || item.invoice_qty - item.qty <= 0 ) {
                return 0;
            } else{
                return item.invoice_qty - item.qty;
            }
        },
        addCart() {
            let cartInd = this.cart.findIndex(
                (p) => p.product_id == this.product_id.value.value
            );

            if (this.product_id.value.value == null) {
                toast.error("Please select a Product");
                this.cartReset();
                return false;
            }

            if (cartInd > -1) {
                toast.error("Product already added in cart");
                this.cartReset();
                return false;
            }

            let product = this.getProductMapList.find(
                (item) => item.product_id == this.product_id.value.value
            );
            product = product.product;

            let item = {
                product_id: this.product_id.value.value,
                product_name: product.name,
                product_code: product.code,
                available_qty: product.available_inventory_qty,
                qty: 1,
                unit_id: product.unit_id,
                unit_name: product.unit.name,
            };

            this.cart.push(item);
            this.$nextTick(() => {
                this.cartReset();
            });
        },
        removeFromCart(index) {
            if (confirm("Are You Sure?")) {
                this.cart.splice(index, 1);
            }
        },
        cartReset() {
            this.product_id.value.value = null;
        },

        async onSaleInvoiceChange(selectedId) {
            if (!selectedId) {
                this.requisition_date.value.value = null;
                this.require_date.value.value = null;
                this.warehouse_id.value.value = null;
                this.department_id.value.value = null;
                this.approximate_delivery_date.value.value = null;
                this.shipping_date.value.value = null;
                this.delivery_address.value.value = "";
                this.customer_name.value.value = "";
                this.cart = []; // Clear cart when deselecting
                return;
            }

            try {
                const response = await this.$store.dispatch("getSaleInvoiceById", selectedId);
                
                this.requisition_date.value.value = response.requisition_date || "";
                this.require_date.value.value = response.require_date || "";

                this.approximate_delivery_date.value.value = response.sale_order?.approximate_delivery_date;
                this.shipping_date.value.value = response.sale_order?.shipping_date;
                this.delivery_address.value.value = response.sale_order?.delivery_address;
                this.customer_name.value.value = response.sale_order?.customer?.company_name    ;
                
                // Clear existing cart before adding new items
                this.cart = [];
                
                
                // Add items to cart
                (response.details || []).forEach((item) => {
                    // Check if product exists and has necessary data
                    if (item.product) {
                        this.cart.push({
                            product_id: item.product_id,
                            product_name: item.product.name || "",
                            product_code: item.product.code || "",
                            invoice_qty: item.qty || 0,
                            free_qty: item.free_qty || 0,
                            delivery_qty: item.delivery_qty || 0,
                            available_qty: item.product.available_inventory_qty || 0,
                            qty: 1,
                            unit_id: item.product.unit?.id || "",
                            unit_name: item.product.unit?.name || "",
                            gifts: (item.gifts || []).map(g => ({
                                product_id: g.product_id,
                                product: g.product,
                                qty: g.quantity || 1,
                                sale_rate: g.sale_rate || 0,
                                description: g.description || '',
                            }))
                        });
                    }
                    // if(item.delivery_qty === item.approval_qty) {
                    //     this.deliveryQtyDisable = true;
                    // }else{
                    //     this.deliveryQtyDisable = false;
                    // }
                });
            } catch (error) {
                console.error("Error loading requisition:", error);
            }
        }
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                // requisition_date: yup.date().required().label("Requisition Date"),
                // require_date: yup.date().nullable().label("Require Date"),
                // department_id: yup.number().positive().integer().required().label("Department Name"),
                // warehouse_id: yup.number().positive().integer().required().label("Designation Name"),
            }),
        });
        const invoice_delivery_master_id = useField("invoice_delivery_master_id");
        const requisition_id = useField("requisition_id");
        const require_date = useField("require_date");
        const product_id = useField("product_id");
        const pr_status = useField("pr_status");
        const status = useField("status");
        const employee_id = useField("employee_id");
        const department_id = useField("department_id");
        const warehouse_id = useField("warehouse_id");
        const sale_invoice_master_id = useField("sale_invoice_master_id");

        const requisition_date = useField("requisition_date");
        const invoice_delivery_date = useField("invoice_delivery_date");
        const remarks = useField("remarks");
        const requsition_by = useField("requsition_by");
        const requsition_by_mobile = useField("requsition_by_mobile");
        const requsition_by_email = useField("requsition_by_email");
        const approximate_delivery_date = useField("approximate_delivery_date");
        const shipping_date = useField("shipping_date");
        const delivery_address = useField("delivery_address");
        const customer_name = useField("customer_name");
        

        

        const errorMessages = ref("");
        const cart = ref([]);
        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";
        const store = useStore();
        const router = useRouter();

        const currentStatus = ref(0);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.status = currentStatus.value;
            values.cart = cart.value;
            store
            .dispatch("saveUpdateInvSalesInvoiceDelivery", values)
            .then((response) => {
                resetForm();
                    buttonText.value = "Save";
                    cart.value = [];
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "sale-delivery-records" });
                    }, 2000);
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
        });
        return {
            submit,
            submitForm,
            invoice_delivery_master_id,
            requisition_id,
            product_id,
            requisition_date,
            invoice_delivery_date,
            require_date,
            remarks,
            cart,
            requsition_by,
            requsition_by_mobile,
            sale_invoice_master_id,
            requsition_by_email,
            pr_status,
            status,
            errorMessages,
            employee_id,
            department_id,
            warehouse_id,
            buttonText,
            loading,
            approximate_delivery_date,
            shipping_date,
            delivery_address,
            customer_name,
            getCompanyInfo,
        };
    },
    mounted() {

        this.isGiftItem = getCompanyInfo()?.is_gift_item ?? false;
        this.isFreeItem = getCompanyInfo()?.is_free_item ?? false;

        this.pr_status.value.value = "1";
        this.status.value.value = 1;
        this.employee_id.value.value = "";
        let user = this.$store.getters.getAuthUser;
        this.requsition_by.value.value = this.$store.getters.getAuthUser.full_name;
        this.requsition_by_mobile.value.value =
        this.$store.getters.getAuthUser.mobile;
        this.requsition_by_email.value.value =
        this.$store.getters.getAuthUser.email;

        // Set require_date to today
        const today = new Date().toISOString().slice(0, 10); // 'YYYY-MM-DD'
        this.require_date.value.value = today;
        this.requisition_date.value.value = today;

        const id = this.$route.query.id;
        if (id) {
            this.$store.commit("SET_LOADING", { color: "primary" });

            this.$nextTick(() => {
                this.$store
                .dispatch("getInvSalesInvoiceDeliveryById", id)
                .then((data) => {
                    this.isEntryMode = false;
                    this.requisitionDisable = true;
                    let requisition = data;
                    this.invoice_delivery_master_id.value.value = requisition.id;
                    this.sale_invoice_master_id.value.value = requisition.sale_invoice_master_id;
                    this.requisition_date.value.value = requisition.requisition_date
                    ? new Date(requisition.requisition_date)
                    : new Date();
                    this.invoice_delivery_date.value.value = requisition.invoice_delivery_date
                    ? new Date(requisition.invoice_delivery_date)
                    : new Date();
                    this.require_date.value.value = requisition.require_date
                    ? new Date(requisition.require_date)
                    : new Date();
                    this.requisition_id.value.value = requisition.requisition_id;
                    this.warehouse_id.value.value = requisition.warehouse.id;
                    this.pr_status.value.value = requisition.pr_status || "1";
                    this.status.value.value = requisition.status || 1;
                    this.product_id.value.value = null;
                    this.cart.value = [];

                    // Insert items one by one
                    (requisition.invoice_delivery_details || []).forEach((item) => {
                        this.cart.push({
                            product_id: item.product_id,
                            product_name: item.product?.name || "",
                            product_code: item.product?.code || "",
                            available_qty: item.product?.available_inventory_qty,
                            delivery_qty: item?.invoice_detail?.delivery_qty || 0,
                            free_qty: item?.free_qty|| 0,
                            invoice_qty: item.invoice_detail.invoice_qty || 0,
                            qty: item.qty,
                            unit_id: item.product.unit?.id || "",
                            unit_name: item.product.unit?.name || "",
                            gifts: (item.gifts || []).map(g => ({
                                product_id: g.product_id,
                                product: g.product,
                                qty: g.quantity || 1,
                                sale_rate: g.sale_rate || 0,
                                description: g.description || '',
                            }))
                        });
                        // if(item.qty === item.invoice_detail.approval_qty) {
                        //     this.deliveryQtyDisable = true;
                        // }else{
                        //     this.deliveryQtyDisable = false;
                        // }
                    });
                    this.remarks.value.value = requisition.remarks
                    ? requisition.remarks
                    : "";
                    this.$store.commit("UNSET_LOADING");
                })
                .catch((error) => {
                    this.$store.commit("UNSET_LOADING");
                    console.error("Failed to fetch requisition:", error);
                });
            });
        } else {
            this.requisition_date.value.value = new Date();
            this.invoice_delivery_date.value.value = new Date();
            this.require_date.value.value = new Date();
            this.isEntryMode = true;
        }
    },
};
</script>
